/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Communicationdefect1Inputs */



/**
* | output |
* | --- |
* | "Communication defect with hardware" |
*
* @param {Br_History_Key_Communicationdefect1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_communicationdefect1 = /** @type {((inputs?: Br_History_Key_Communicationdefect1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Communicationdefect1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Communication defect with hardware")
	return /** @type {LocalizedString} */ ("Défaut communication avec le matériel")
});
export { br_history_key_communicationdefect1 as "br_history_key_communicationDefect" }